import { SiGithub, SiTelegram, SiVk } from "react-icons/si";
import { FaDiscord } from "react-icons/fa";

import styles from "./SocialMediaBadge.module.scss";

const SOCIAL_MEDIA = {
  github: {
    icon: SiGithub,
    prettyName: "GitHub",
    url: "https://github.com/exodie",
  },

  telegram: {
    icon: SiTelegram,
    prettyName: "Telegram",
    url: "https://t.me/sa_skja",
  },

  vk: {
    icon: SiVk,
    prettyName: "VK",
    url: "https://vk.com/s8k1_2",
  },

  discord: {
    icon: FaDiscord,
    prettyName: "Discord",
    url: "https://discordapp.com/users/919895616321097748",
  },
};

function SocialMediaBadge({ type }) {
  const ICON = SOCIAL_MEDIA[type].icon;

  return (
    <a
      className={styles.base}
      href={SOCIAL_MEDIA[type].url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ICON className={styles.icon} />
      <span>{SOCIAL_MEDIA[type].prettyName}</span>
    </a>
  );
}

export default SocialMediaBadge;
